import { CountUp, Reveal } from "@/components/brand";
import { stats } from "@/lib/offer";

export default function ProofStrip() {
  return (
    <section data-testid="proof-strip" className="border-y border-border bg-muted">
      <dl className="mx-auto grid max-w-7xl grid-cols-1 divide-y divide-border px-4 sm:grid-cols-3 sm:divide-x sm:divide-y-0 sm:px-6 lg:px-8">
        {stats.map((stat, i) => (
          <Reveal key={stat.value} delay={i * 0.08} className="py-7 sm:px-8 sm:first:pl-0">
            <dt className="sr-only">{stat.label}</dt>
            <dd className="text-3xl font-bold tracking-[-0.03em] text-primary md:text-4xl">
              <CountUp value={stat.value} />
            </dd>
            <dd className="mt-1 text-sm text-muted-foreground">{stat.label}</dd>
          </Reveal>
        ))}
      </dl>
    </section>
  );
}
